<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'標籤列表'"></page-title>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="$router.push(`/tag-group/${groupID}`)">修改標籤類別</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>標籤名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="clearAll">清除搜尋結果</md-button>
          <md-button class="md-raised md-primary" @click="$router.push(`/tag-group/${groupID}/tag/add`)">新增標籤</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="getTags()">搜尋</md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head>名稱</md-table-head>
            </md-table-row>
            <md-table-row v-for="(tag, index) in tags" :tags="tags" :key="tag.id">
              <md-table-cell>
                <router-link :to="`/tag-group/${tag.tag_group_id}/tag/${tag.id}`">
                  {{tag.name}}
                </router-link>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <paginate
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getTags"
            :prev-text="'前頁'"
            :next-text="'下頁'"
            :container-class="'pagination'"
            :no-li-surround="true"
          >
          </paginate>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="$router.back()">返回</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'
import Paginate from 'vuejs-paginate'

export default {
  data () {
    return {
      pageCount: 0,
      data: {
        name: null
      },
      tags: []
    }
  },
  components: {
    PageTitle, Paginate
  },
  created () {
    this.groupID = this.$route.params.groupID
    this.getTags()
  },
  methods: {
    clearAll: async function () {
      this.tags = []
    },
    getTags: async function (page = 1) {
      for (var i in this.data) {
        if (this.data[i] === '') {
          this.data[i] = null
        }
      }
      let req = await axios.get(urls({route: `tag-group/${this.groupID}/tag`}), {params: {page, ...this.data}})
      this.tags = req.data.data
      this.pageCount = req.data.count
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Tag/TagList.vue